import {
    apiTransitionPersonalDetailsForm,
    submitPersonalDetailsDataSuccess
} from '../../../actions/motorPrivateRW/personalDetails';
import { getAccessToken } from '../../../selectors/motorPrivateRW/payments';
import axios from 'axios';
import { getApiQuoteResponse } from '../../../selectors/motorPrivateRW/quote';
import { getPersonalDetailsForm } from '../../../selectors/motorPrivateRW/personalDetails';

export const savePersonalDetailsService = (store, next, action) => {
    (async () => {
        store.dispatch(apiTransitionPersonalDetailsForm.pending());
        try {
            const resp = await savePersonalDetails(store.getState());
            store.dispatch(submitPersonalDetailsDataSuccess(resp.data));
            store.dispatch(apiTransitionPersonalDetailsForm.success());
        } catch (e) {
            console.error(e);
            store.dispatch(apiTransitionPersonalDetailsForm.failure());
        }
    })();
    return next(action);
};

export function convertDateFormat2(dateString) {
    try {
        // Split the date string into year, month, and day
        var parts = dateString.split('/');
        var year = parts[2];
        var month = parts[1];
        var day = parts[0];

        // Reformat the date string in the desired format
        var formattedDate = month + '-' + day + '-' + year;

        return formattedDate;
    } catch (error) {
        // Handle the case where the input string is not in the expected format
        return 'Invalid date format. Please use yyyy-mm-dd.';
    }
}


const savePersonalDetailsPayload = state => {
    const savedQuoteResponse = getApiQuoteResponse(state);
    const quoteId = savedQuoteResponse?.data?.quotation?.id;
    const personalDetails = getPersonalDetailsForm(state);

    const payload = {
        quoteId,
        firstName: personalDetails.firstName.value || 'N/A',
        lastName: personalDetails.lastName.value || 'N/A',
        dateOfBirth: convertDateFormat2(personalDetails.dob.value) || 'N/A',
        idType: personalDetails.idType.value || 'N/A',
        idNumber: personalDetails.idNumber.value || 'N/A',
        phoneNumber: personalDetails.phoneNumber.value || 'N/A',
        emailAddress: personalDetails.email.value || 'N/A',
        gender: personalDetails.gender.value || 'N/A',
        salutation: personalDetails.salutation.value || 'N/A',
        district: personalDetails.district.value || 'N/A',
        sector: personalDetails.sector.value || 'N/A',
        cell: personalDetails.cell.value || 'N/A',
        village: personalDetails.village.value || 'N/A'
    };

    // Change payload here
    return {
        ...payload
    };
};

const savePersonalDetails = async state => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/rw-motor-insurance/save/personal-details';
        return await axios.post(url, savePersonalDetailsPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa'
            }
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
